export enum Routes {
  FleetWarehouseRouter = '*',
  FleetWarehouseSearchPageRouter = '/fleet/warehouse/search',
  FleetWarehouseDetailPageRouter = '/fleet/warehouse/:id/detail/',
  FleetWarehouseEditPageRouter = '/fleet/warehouse/:id/edit/',
  FleetWarehouseCreatePageRouter = '/fleet/warehouse/new',
  FleetWarehouseTireSetSearchPageRouter = '/fleet/warehouse/:id/tireset',
}


